module.exports = __webpack_public_path__ + "media/images/blogapalooza-4ecc66ccc204151e7875fe31ec325b87.png";